<template>
  <div
    class="page-content-wrap service-form-wrap page-wrapper bg-gra-02 p-t-10 p-b-100 font-poppins"
  >
    <FileFullPreviewMode></FileFullPreviewMode>
    <form @submit.prevent="onSubmit($event)">
      <div class="wrapper wrapper--wide">
        <div class="card card-12">
          <div class="card-body">
            <div
              v-if="data.status == 'revise' && data.revise_comments"
              class="row"
            >
              <div class="col-12">
                <div
                  class="alert alert-warning alert-content"
                  v-html="data.revise_comments"
                ></div>
              </div>
            </div>

            <div class="row row-service-form btn-row row-space">
              <div
                v-for="(attribute, index) in service.data_form"
                :key="index"
                :class="`col-xs-${
                  attribute.layout && attribute.layout.m_col
                    ? attribute.layout.m_col
                    : 12
                } col-sm-${
                  attribute.layout && attribute.layout.t_col
                    ? attribute.layout.t_col
                    : 12
                } col-md-${
                  attribute.layout && attribute.layout.d_col
                    ? attribute.layout.d_col
                    : 12
                } col-service-form`"
              >
                <template v-if="attribute.kind == 'form_data'">
                  <div class="input-group">
                    <label class="label">
                      <span
                        :class="`label-content label-xs-${
                          attribute.layout && attribute.layout.m_n == '0'
                            ? 'hide'
                            : 'show'
                        } label-sm-${
                          attribute.layout && attribute.layout.t_n == '0'
                            ? 'hide'
                            : 'show'
                        } label-md-${
                          attribute.layout && attribute.layout.d_n == '0'
                            ? 'hide'
                            : 'show'
                        }`"
                      >
                        <template>
                          {{ attribute.name[`${$app.lang}`] }}
                        </template>
                      </span>
                    </label>

                    <!-- Form data / Text -->
                    <div v-if="attribute.type == 'text'" class="info-value">
                      {{ attribute.valueLang[`${$app.lang}`] }}
                    </div>

                    <!-- Form data / Textarea -->
                    <div v-if="attribute.type == 'textarea'" class="info-value">
                      {{ attribute.valueLang[`${$app.lang}`] }}
                    </div>

                    <!-- Form data / Wysiwyg -->
                    <div
                      v-if="attribute.type == 'wysiwyg'"
                      class="info-value"
                      v-html="attribute.valueLang[`${$app.lang}`]"
                    ></div>
                  </div>
                </template>

                <template
                  v-if="attribute.kind == 'component' && canDisplay(attribute)"
                >
                  <div class="input-group">
                    <label class="label">
                      <span
                        :class="`label-content label-xs-${
                          attribute.layout && attribute.layout.m_n == '0'
                            ? 'hide'
                            : 'show'
                        } label-sm-${
                          attribute.layout && attribute.layout.t_n == '0'
                            ? 'hide'
                            : 'show'
                        } label-md-${
                          attribute.layout && attribute.layout.d_n == '0'
                            ? 'hide'
                            : 'show'
                        }`"
                      >
                        <template
                          v-if="attribute.type == 'service_form_fullname'"
                        >
                          Pareiškėjas
                        </template>
                        <template v-if="attribute.type == 'service_form_email'">
                          El. pašto adresas
                        </template>
                        <template
                          v-if="
                            attribute.type == 'service_form_price' &&
                            service.user_price_enabled
                          "
                        >
                          {{ attribute.name[`${$app.lang}`] }}
                        </template>
                      </span>
                    </label>
                    <template v-if="attribute.type == 'service_form_fullname'">
                      <input
                        :id="attribute.identifier"
                        v-model="fullName"
                        :name="attribute.identifier"
                        class="input--style-ep"
                        type="text"
                        disabled
                      />
                    </template>
                    <template v-if="attribute.type == 'service_form_email'">
                      <input
                        :id="attribute.identifier"
                        v-model="email"
                        :name="attribute.identifier"
                        class="input--style-ep"
                        type="text"
                        disabled
                      />
                    </template>
                    <template
                      v-if="
                        attribute.type == 'service_form_price' &&
                        service.user_price_enabled
                      "
                    >
                      <input
                        :id="attribute.identifier"
                        v-model="model.form_data[`${attribute.identifier}`]"
                        :name="attribute.identifier"
                        type="number"
                        class="input--style-ep"
                        step="0.01"
                        min="0.01"
                        @input="setUserPrice"
                      />
                    </template>
                  </div>
                </template>

                <template v-if="attribute.kind !== 'form_data'">
                  <template v-if="attribute.kind == 'form_element'">
                    <div class="input-group">
                      <label class="label">
                        <span
                          :class="`label-content label-xs-${
                            attribute.layout && attribute.layout.m_n == '0'
                              ? 'hide'
                              : 'show'
                          } label-sm-${
                            attribute.layout && attribute.layout.t_n == '0'
                              ? 'hide'
                              : 'show'
                          } label-md-${
                            attribute.layout && attribute.layout.d_n == '0'
                              ? 'hide'
                              : 'show'
                          }`"
                        >
                          <template v-if="attribute.type != 'toggle'">
                            {{ attribute.name[`${$app.lang}`] }}
                          </template>
                          <template
                            v-if="
                              getAttributeRequiredFlag(attribute) &&
                              attribute.type != 'toggle'
                            "
                          >
                            <span class="required-symbol">*</span>
                          </template>
                        </span>
                      </label>

                      <!-- Form element / Text -->

                      <template v-if="attribute.type == 'text'">
                        <input
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          :name="attribute.identifier"
                          class="input--style-ep"
                          type="text"
                          :placeholder="attribute.placeholder[`${$app.lang}`]"
                        />
                      </template>

                      <!-- Form element / Textarea -->

                      <template v-if="attribute.type == 'textarea'">
                        <textarea
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          :name="attribute.identifier"
                          class="input--style-ep"
                          rows="4"
                          :placeholder="attribute.placeholder[`${$app.lang}`]"
                        ></textarea>
                      </template>

                      <!-- Form element / Wysiwyg -->

                      <template v-if="attribute.type == 'wysiwyg'">
                        <rich-text-editor
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          :name="attribute.identifier"
                          class="input--style-ep"
                        ></rich-text-editor>
                      </template>

                      <!-- Form element / Email -->

                      <template v-if="attribute.type == 'email'">
                        <input
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          :name="attribute.identifier"
                          type="email"
                          class="input--style-ep"
                          :placeholder="attribute.placeholder[`${$app.lang}`]"
                        />
                      </template>

                      <!-- Form element / Number -->

                      <template v-if="attribute.type == 'number'">
                        <input
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          :name="attribute.identifier"
                          type="number"
                          class="input--style-ep"
                          :placeholder="attribute.placeholder[`${$app.lang}`]"
                        />
                      </template>

                      <!-- Form element / Select  -->

                      <template v-if="attribute.type == 'select'">
                        <div
                          class="rs-select2 js-select-simple select--no-search"
                        >
                          <b-form-select
                            :id="attribute.identifier"
                            v-model="model.form_data[`${attribute.identifier}`]"
                            :name="attribute.identifier"
                            class="form-control form-control-format select-box-with-arrow"
                          >
                            <!-- This slot appears above the options from 'options' prop -->
                            <template #first>
                              <b-form-select-option
                                :value="
                                  _.isEmpty(
                                    model.form_data[`${attribute.identifier}`],
                                  )
                                    ? model.form_data[`${attribute.identifier}`]
                                    : null
                                "
                              >
                                {{
                                  attribute.placeholder[`${$app.lang}`]
                                    ? attribute.placeholder[`${$app.lang}`]
                                    : $t('services.label.please-select')
                                }}
                              </b-form-select-option>
                            </template>
                            <b-form-select-option
                              v-for="(option, optionIdx) in attribute.options"
                              :key="optionIdx"
                              :value="option.id"
                            >
                              {{ option.text }}
                            </b-form-select-option>
                          </b-form-select>
                        </div>
                      </template>

                      <!-- Form element / Checkbox  -->

                      <template v-if="attribute.type == 'checkbox'">
                        <b-form-checkbox-group
                          v-model="model.form_data[`${attribute.identifier}`]"
                          stacked
                          :name="`${attribute.identifier}[]`"
                        >
                          <b-form-checkbox
                            v-for="option in attribute.options"
                            :key="option.value"
                            v-b-tooltip.left
                            :value="option.value"
                          >
                            {{ option.text }}
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </template>

                      <!-- Form element / Radio  -->

                      <template v-if="attribute.type == 'radio'">
                        <b-form-radio-group
                          :id="attribute.identifier"
                          v-model="model.form_data[`${attribute.identifier}`]"
                          stacked
                          :options="attribute.options"
                          :name="attribute.identifier"
                        >
                        </b-form-radio-group>
                      </template>

                      <!-- Form element / Upload  -->
                      <template v-if="attribute.type == 'upload'">
                        <FileUpload
                          module="formrecords"
                          :identifier="attribute.identifier"
                          :unique-folder-id="
                            model.form_data[attribute.identifier]
                          "
                          :multiple="isFileUploadMultiple(attribute)"
                        ></FileUpload>
                      </template>

                      <!-- Form element / Toogle -->

                      <template v-if="attribute.type == 'toggle'">
                        <div class="toggle-wrap">
                          <template v-if="getAttributeRequiredFlag(attribute)">
                            <span class="required-symbol">*</span>
                          </template>
                          <c-switch
                            v-model="model.form_data[`${attribute.identifier}`]"
                            :name="attribute.identifier"
                            :description="attribute.name[`${$app.lang}`]"
                            :class="
                              getAttributeRequiredFlag(attribute)
                                ? 'required-switch'
                                : ''
                            "
                          >
                          </c-switch>
                        </div>
                      </template>

                      <small
                        v-if="attribute.note[`${$app.lang}`]"
                        tabindex="-1"
                        class="form-text text-muted field-notes"
                      >
                        {{ attribute.note[`${$app.lang}`] }}
                      </small>
                      <div
                        v-if="state('form_data.' + attribute.identifier)"
                        class="form-validation row"
                        :class="state('form_data.' + attribute.identifier)"
                      >
                        <div class="col-lg-12">
                          <b-form-feedback
                            v-html="
                              feedback('form_data.' + attribute.identifier)
                            "
                          >
                          </b-form-feedback>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>
            <div class="row row-service-form btn-row-wrap">
              <div
                class="col-xs-12 col-md-12 col-value"
                style="text-align: right"
              >
                <button
                  class="btn btn-primary blue btn-full-width"
                  type="submit"
                  :disabled="isUploading || isBusy"
                  :aria-busy="isUploading ? 'true' : 'false'"
                >
                  <span v-if="isUploading">Įkeliami failai…</span>
                  <span v-else>
                    Toliau <i class="fas fa-chevron-right" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import form from '@core/js/mixins/form'
import RichTextEditor from '@core/js/components/Plugins/RichTextEditor'
import FileUpload from '@assets/js/components/Upload/FileUpload'
import FileFullPreviewMode from '@assets/js/components/Preview/FileFullPreviewMode'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  name: 'ServiceForm',
  components: { RichTextEditor, FileFullPreviewMode, FileUpload },
  title: '',
  mixins: [form],
  props: {
    service: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    fullName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      modelName: 'formRecord',
      resourceRoute: 'formRecords',
      routePath: '/account/services/create',
      createPath: '/account/services/create',
      updatePath: '/account/services/update',
      continuePath: '/account/services',
      isBusy: false,
    }
  },
  computed: {
    ...mapGetters(['filesInQueueTotal', 'isProcessingFile']),
    isUploading() {
      return this.filesInQueueTotal > 0 || this.isProcessingFile
    },
    model() {
      return this.$store.getters['form/data']
    },
  },
  created() {},
  mounted() {
    this.$elementEqualHeight('.col-service-form label')
  },
  beforeMount() {
    if (this.mode == 'create') {
      this.$store.commit('form/setDataInit', this.service)
      this.$store.commit('form/emptyFields')
      this.model.id = 'undefined'
    } else {
      this.$store.commit('form/setData', this.data)
    }
  },
  destroyed() {},
  methods: {
    // Determine if file upload should allow multiple files (service form)
    isFileUploadMultiple(attribute) {
      // Prefer explicit flags when present
      if (
        attribute &&
        (attribute.multiple === true ||
          (attribute.max && Number(attribute.max) > 1))
      )
        return true
      if (
        attribute &&
        attribute.validation &&
        attribute.validation.multiple === true
      )
        return true
      // Default: single-file for services form
      return true
    },
    canDisplay: function (attribute) {
      if (attribute.type == 'service_form_price') {
        if (this.service.user_price_enabled) {
          return true
        }
        return false
      }

      return true
    },
    setUserPrice: function (event) {
      this.$store.commit('form/setUserPrice', event.target.value)
    },
    getAttributeRequiredFlag(param) {
      if (param && param.hasOwnProperty('validation')) {
        let validation = param['validation']
        if (validation && validation.hasOwnProperty('required')) {
          let value = param['validation']['required']
          if (value == 1 || value == true || value == '1' || value == 'true') {
            return true
          }
        }
      }
      return false
    },
  },
}
</script>
